import api from './apis/index';
import history from '../history';
import { ERROR_MESSAGE, LOADED, LOADING, SUCCESS_MESSAGE, VALIDATION_ERROR } from './types';

export const notificationCount = () => async (dispatch) => {

    try{
        const response = await api(localStorage.getItem("token")).get('/notification/count');
        if(response.status === 200 ){
                    dispatch({type: LOADED})
                    return response.data.count
                
        }
    }
    catch(err){
        
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          
          if(err?.response?.status === 451 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            history.push('/pending-verification')
          }

          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }

          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err?.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
}
export const notificationList = () => async (dispatch) => {
    dispatch({type: LOADING})
    try{
        const response = await api(localStorage.getItem("token")).get('/notification');
        if(response.status === 200 ){
            dispatch({type: LOADED})
            return response.data.notification
        }
    }
    catch(err){
        
        if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          
        if(err.message == 'Network Error')
        {
            history.push('/maintenance')
            return
        }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
}

export const ticketCount = () => async (dispatch) => {
    
    dispatch({type: LOADING})
    try{
        const response = await api(localStorage.getItem("token")).get('/ticket/count');
        if(response.status === 200 ){
            dispatch({type: LOADED})
            return response.data.count
        }
    }
    catch(err){
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          
          if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
}

export const dashboardStat = () => async (dispatch) => {
    
    dispatch({type: LOADING})
    try{
        const response = await api(localStorage.getItem("token")).get('/dashboard');
        if(response.status === 200 ){
            dispatch({type: LOADED})
            return response.data.data
        }
        
    }
    catch(err){
        if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }

          if(err?.response?.status === 451 ){
            history.push('/pending-verification')
          }
          
      
          if(err.message == 'Network Error')
          {
              history.push('/maintenance')
              return
          }
          dispatch({ type: ERROR_MESSAGE, payload: err?.response ? err.response.data.message : history.push('/404') });
          dispatch({type: LOADED});
    }
}